import { render } from "./editProcurement.vue?vue&type=template&id=7104a3a6&scoped=true"
import script from "./editProcurement.vue?vue&type=script&lang=js"
export * from "./editProcurement.vue?vue&type=script&lang=js"

import "./editProcurement.vue?vue&type=style&index=0&id=7104a3a6&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7104a3a6"]])

export default __exports__